export default [
  {
    type: 'email',
    name: 'email',
    label: 'Email Address',
    validation: '^required|email'
  },
]